import React from 'react'
import type { RuleDisagreement } from '../../utils/appendixConsistency'
import { formatCombinationCount } from '../../utils/appendixConsistency'
import { UNSELECTABLE_VALUES_RECHECK_INSTRUCTION } from './UnselectableValuesBanner'

type AppendixDisagreementBadgeProps = {
  disagreements: RuleDisagreement[]
  // The rule or a code item an appendix covers changed since the last save.
  needsRecheck: boolean
  onOpenAppendix?: (appendixId: string) => void
  testId?: string
}

/**
 * Under a rule that takes part in a disagreement with a valid-combination appendix: which appendix
 * and how many of its combinations, with a way to open it. The combinations themselves and the ways
 * out stay on the appendix.
 */
export default function AppendixDisagreementBadge({
  disagreements,
  needsRecheck,
  onOpenAppendix,
  testId,
}: AppendixDisagreementBadgeProps) {
  if (disagreements.length === 0) return null

  return (
    <div data-testid={testId} className="mt-1 space-y-0.5">
      {disagreements.map(disagreement => {
        const appendix = disagreement.letter ? `Appendix ${disagreement.letter}` : disagreement.title
        return (
          <div key={disagreement.appendixId} className="text-[11px] leading-4 text-[#B3261E]">
            <span className="font-semibold">Disagrees with {appendix}</span>
            {' · '}
            {formatCombinationCount(disagreement.combinationCount)}
            {needsRecheck ? <span className="italic"> · {UNSELECTABLE_VALUES_RECHECK_INSTRUCTION.toLowerCase()}</span> : null}
            {onOpenAppendix ? (
              <>
                {' · '}
                <button
                  type="button"
                  className="cursor-pointer font-medium underline underline-offset-2"
                  onClick={(event) => {
                    event.stopPropagation()
                    onOpenAppendix(disagreement.appendixId)
                  }}
                >
                  Open {appendix}
                </button>
              </>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
